import React, { useContext, useEffect, useState, useRef } from "react";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { spiderData } from "../../../api/s3";
import { Loader } from "../../../components/loader/Loader";
import {
  onAction,
  factory,
  layoutModelChange,
  onRenderTabSet,
} from "./layoutFunctions";
import "../../../layout/layoutstyle.css";

const RELOAD_DELAY_FOR_COGNITO = 1500;

export const RelativePerformanceLayout = () => {
  const [store] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState, setLayoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);
  const [modelDate_y, setModelDate_y] = useState();
  const [incognitoError, setIncognitoError] = useState(false);
  const reloadRef = useRef(null);

  const { auth, incognito } = store;

  if (lstore) {
    //do nothing
  }

  useEffect(() => {
    if (incognitoError && incognito) {
      if (reloadRef) {
        console.log('reload')
        setTimeout(() => window.location.reload(), RELOAD_DELAY_FOR_COGNITO);
      }
    }
  }, [incognitoError, incognito]);

  useEffect(() => {
    let isCancelled = false;

    const asyncfunction = async () => {
      ldispatch({ type: lactionTypes.SET_LOADING, payload: true });
      const newState = {
        rawdata: [],
      };
      try {
        const sdata = await spiderData(auth, grefs.tickerStorage.current);
        setModelDate_y(
          Array.from(
            new Set(
              sdata
                .filter((item, i) => item["Column_53"] && i > 0)
                .map((item) => item["Column_53"])
            )
          )[0]
        );
        newState.rawdata = sdata;
        if (!isCancelled) {
          ldispatch({
            type: lactionTypes.SET_RELATIVEPERFORMANCE,
            payload: newState,
          });
          ldispatch({ type: lactionTypes.SET_LOADING, payload: false });
        }
      } catch (error) {
        if (error === "No current user") {
          setIncognitoError(true);
        }
      }
    };
    asyncfunction();

    return () => {
      isCancelled = true;
    };
  }, [auth, ldispatch, grefs.tickerStorage]);

  if (layoutState.model && modelDate_y && !incognitoError) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={(node) => factory(node, modelDate_y)}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) =>
          layoutModelChange(model, layoutState, setLayoutState, grefs)
        }
        onAction={(action) => onAction(action, layoutState)}
      />
    );
  } else return <Loader />;
};
